"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.customModel.exceeded': '已达到自定义AI模型限制。升级您的计划以训练更多模型。',
    'limits.customModel.limitReached': '自定义模型限制：{limit}（升级以训练更多）',
};
